import { ACTIONS } from '../actions/locale'

export const initialState = {
    appState: {
        showPopupLocale: false,
    },
    database: {
        exchangeRates: {},
    },
}

export default (state = initialState, action) => {
    const { appState, database } = state
    let newAppState = { ...appState }
    let newDatabase = { ...database }

    switch (action.type) {
        case ACTIONS.GET_EXCHANGE_RATES:
            newDatabase.exchangeRates = action.data

            return {
                ...state,
                database: newDatabase,
            }

        case ACTIONS.TOGGLE_POPUP_LOCALE:
            newAppState.showPopupLocale = action.data

            return {
                ...state,
                appState: newAppState,
            }

        default:
            return state
        }
}
